import { DatabaseCoverage } from 'dashboard/models/database-coverage';
import Action from 'lib/interfaces/Action';

export type DatabaseCoverageActions = Action<
  DatabaseCoverageActionType.SetDatabaseCoverage,
  SetDatabaseCoveragePayload
>;

export enum DatabaseCoverageActionType {
  SetDatabaseCoverage = 'SET_DATABASE_COVERAGE',
}

interface SetDatabaseCoveragePayload {
  databaseCoverage: DatabaseCoverage;
}

export function setDatabaseCoverage(
  databaseCoverage: DatabaseCoverage,
): Action<DatabaseCoverageActionType.SetDatabaseCoverage, SetDatabaseCoveragePayload> {
  return {
    payload: {
      databaseCoverage,
    },
    type: DatabaseCoverageActionType.SetDatabaseCoverage,
  };
}
